export default __webpack_public_path__ + "static/media/TV-2023-main-visual-4K_1x1.f41c223a.webp";